import PaginatedList from "#root/components/paginated-list";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { getNewsRPMInstanceByCode } from "#root/schema/platform/newsrpm-instance";
import { newsRPMInstanceCollection } from "#root/schema/platform/newsrpm-marketplace";
import PageLayout from "./layout";

function Health({ code, children }) {
  const [health] = useData(async () => {
    try {
      const response = await getNewsRPMInstanceByCode(code).fetch("status");
      if (response.ok) return response.text();
    } catch {
    }

    return "OFFLINE";
  }, [code]);

  return children(health);
}

export default function InstanceListPage(): ReactNode {
  return (
    <PageLayout title="NewsRPM - Instances">
      <PaginatedList title="NewsRPM Instances" collection={newsRPMInstanceCollection} allowSearch={false}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Instance Code</th>
              <th>Instance Health</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ code }) => (
              <Health key={code} code={code}>
                {health => (
                  <tr className={health === "OFFLINE" ? "error" : ""}>
                    <td>{code}</td>
                    <td>{health}</td>
                    <td>
                      <Link to={`/admin/platform/newsrpm-instance/${code}/article`}>Articles</Link>&nbsp;&middot;&nbsp;
                      <Link to={`/admin/platform/newsrpm-instance/${code}/filter`}>Content Filters</Link>&nbsp;&middot;&nbsp;
                      <Link to={`/admin/platform/newsrpm-instance/${code}/destination`}>Destinations</Link>&nbsp;&middot;&nbsp;
                      <Link to={`/admin/platform/newsrpm-instance/${code}/feed`}>Feeds</Link>&nbsp;&middot;&nbsp;
                      <Link to={`/admin/platform/newsrpm-instance/${code}/usage`}>Usage</Link>
                    </td>
                  </tr>
                )}
              </Health>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
